const isRicosPaletteRgb = (palette) => typeof palette === "object" && "type" in palette && palette.type === "rgb";
export {
  isRicosPaletteRgb
};
//# sourceMappingURL=identifiers.js.map
